<template>
<div>
   <viewMessage v-if='currentMessage' @clickoutside='currentMessage=null' :messageId='currentMessage.messageID' :inputMessage='currentMessage'/>
   <v-card
    color="grey lighten-4"
    flat
    height="200px"
    tile
  >
    <v-toolbar>

      <v-toolbar-title>My Message</v-toolbar-title>

      <v-spacer></v-spacer>

      <composeMessage :userData='null'/>
    </v-toolbar>
      <v-tabs v-model='tab'>
    <v-tab href="#tab-1">Inbox</v-tab>
    <v-tab href="#tab-2">Sent Messages</v-tab>
  </v-tabs>
   <v-tabs-items v-model="tab">

      <v-tab-item 
        :value="'tab-1'"
      >
        <v-card flat>
          <v-card-text>

             <v-list
              two-line>
              <center
                v-if="inboxMessages.length === 0">
                You have no messages at this time.
              </center>
             
                <v-list-item
                  :key='index'
                  v-for='(message,index) in inboxMessages'
                  @click='initMessage(message)' >
                  <v-list-item-action>
                    <!-- redundant? -->
                    <v-icon color="primary" v-if='!message.read'>mdi-email</v-icon>
                    <v-icon color="primary" v-else>mdi-email-open</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{message.title}}</v-list-item-title>
                     <v-list-item-subtitle>Last message sent on {{message.messageThread[message.messageThread.length -1].createdAt}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
            
          </v-card-text>
        </v-card>
      </v-tab-item>

       <v-tab-item 
        :value="'tab-2'"
      >
        <v-card flat>
          <v-card-text>
             <v-list
              two-line>
              <center
                v-if="sentMessages.length === 0">
                You have no messages at this time.
              </center>
             
                <v-list-item
                  :key='index'
                  v-for='(message,index) in sentMessages'
                  @click='initMessage(message)' >
                  <v-list-item-action>
                    <!-- redundant? -->
                    <v-icon color="primary" v-if='!message.read'>mdi-email</v-icon>
                    <v-icon color="primary" v-else>mdi-email-open</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{message.title}}</v-list-item-title>
                     <v-list-item-subtitle>Last message sent on {{message.messageThread[message.messageThread.length -1].createdAt}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
  </div>
</template>

<script>
import composeMessage from "../components/myTasks/composeMessageModal"
import { postReq,replyMessage} from '../helper/firestore'
import { mapFields } from 'vuex-map-fields';
import viewMessage from '../components/message/viewMessage'
export default {
  poprs : {
    messages : Object
  },
  data() {
    return {
      replyMessage : null,
      currentMessage : null,
      messageDialog : false,
      tab : null,
      inboxMessages : [],
      sentMessages : [],
    }
  },
  components : {
    composeMessage,viewMessage
  },
          computed : {
    ...mapFields([
      'myMessage',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    },
  mounted() {
    if(this.myMessage !== null){
      this.inboxMessages  = this.myMessage.to
      this.sentMessages = this.myMessage.from
    }else{
      this.fetchMesssage()
    }
  },
  methods : {

    initMessage(message){
      this.currentMessage = message
      this.messageDialog = true
    },
    fetchMesssage(){
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/messages/getmessages',{uid : this.user.uid},response =>{
      this.myMessage = response.data
      this.inboxMessages  = this.myMessage.message_to
      this.sentMessages = this.myMessage.message_from
        })
    }
  }
}
</script>

<style>

</style>